import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import {
  getBidMode,
  saveBidMode,
  BidMode
} from '../../../../scenes/BidSession/helpers.js';
import { DefaultButton } from '../../../../components/Buttons';
import AlertDialog from '../../../../components/AlertDialog';
import { useLanguage } from '../../../../context/LanguageContext';
import './styles.scss';

export const CustomFormControl = withStyles({
  root: {
    minWidth: 200,
    padding: 'inherit',
  }
})(FormControl);

export const ButtonFormControl = withStyles({
  root: {
    paddingLeft: '250px',
    paddingTop: '32px',
    minWidth: 150,
    padding: 'inherit',
  }
})(FormControl);

const SaveApplyButton = withStyles({
  root: {
    minWidth: 88,
   backgroundColor: 'rgba(229,229,229,0.7)',
    borderColor: '#5E5E5E',
    color: '#5E5E5E',
  },
})(DefaultButton);

class Weight extends Component {
  state = {
    value: BidMode.MANUAL.weightingMode,
    open: false,
    disable: true
  };

  componentDidMount() {
    const bidMode = getBidMode();
    if (bidMode) {
      this.setState({ value: BidMode[bidMode].weightingMode });
    } else {
      this.setState({ value: BidMode.NONE.weightingMode });
      saveBidMode(BidMode.NONE.biddingMode);
    }
  }

  handleChange = (event) => {
    this.setState({ value: event.target.value, disable: false });
  };
  handleOk = () => {
    const bidMode = this.state.value === BidMode.MANUAL.weightingMode ? BidMode.MANUAL.biddingMode : BidMode.AUTOMATIC.biddingMode;
    const changedWeight = bidMode === BidMode.MANUAL.biddingMode ? BidMode.MANUAL.changedWeight : BidMode.AUTOMATIC.changedWeight;
    this.props.handleBidMode(bidMode, changedWeight);
    saveBidMode(bidMode);
    this.setState({ open: false, disable: false });
  };
  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const SETTINGS = this.props.labels?.SETTINGS || {};
    const commonLabels = this.props.labels?.commonLabels || {};

    let handleOkAction;
    let handleCancelAction;
    let dialogMessage;
    let dialogTitle;
    const lastOpenedBidMode = getBidMode();
    if (lastOpenedBidMode !== BidMode.MANUAL.biddingMode
        && lastOpenedBidMode !== BidMode.AUTOMATIC.biddingMode) {
      handleOkAction = this.handleClose;
      handleCancelAction = this.handleClose;
      dialogTitle = SETTINGS.DIALOG?.dialogTitleMode;
      dialogMessage = SETTINGS.DIALOG?.dialogMessageMode;
    } else if (this.state.value === BidMode.AUTOMATIC.weightingMode) {
      handleOkAction = this.handleOk;
      handleCancelAction = this.handleClose;
      dialogTitle = SETTINGS.DIALOG?.dialogTitleManual;
      dialogMessage = SETTINGS.DIALOG?.dialogMessageManual;
    } else {
      handleOkAction = this.handleOk;
      handleCancelAction = this.handleClose;
      dialogTitle = SETTINGS.DIALOG?.dialogTitleAutomatic;
      dialogMessage = `${SETTINGS.DIALOG?.dialogMessageAutomatic + BidMode.MANUAL.changedWeight}.`;
    }

    return (
      <div>
        <Card style={{ marginTop: 20 }}>
          <CardHeader title={SETTINGS.WEIGHT?.TITLE} className="Open-Search-Head" />
          <CardContent>
            <CustomFormControl>
              <InputLabel id="simple-select-label">{SETTINGS.WEIGHT?.SUBTITLE}</InputLabel>
              <Select value={this.state.value || 1} onChange={e => this.handleChange(e)}>
                <MenuItem value={2} >{SETTINGS.WEIGHT?.BASIC}</MenuItem>
                <MenuItem value={1} >{SETTINGS.WEIGHT?.ADVANCED}</MenuItem>
              </Select>
            </CustomFormControl>
            <ButtonFormControl>
              <SaveApplyButton
                onClick={this.handleOpen}
                className="button-actions"
                disabled={this.state.disable}
              >{SETTINGS.LANGUAGE?.save}</SaveApplyButton>
            </ButtonFormControl>
          </CardContent>
        </Card>
        <AlertDialog
          alertDialogTitle={dialogTitle}
          openAlertDialog={this.state.open}
          alertDialogMessage={dialogMessage}
          handleOk={handleOkAction}
          handleCancel={handleCancelAction}
          okButtonLabel={SETTINGS.LANGUAGE?.save}
          cancelButtonLabel={SETTINGS.LANGUAGE?.cancel}
        />
      </div>
    );
  }
}
Weight.defaultProps = {
  handleBidMode: () => {}
};
Weight.propTypes = {
  handleBidMode: PropTypes.func
};
const mapStateToProps = state => ({ ...state.home });

const mapDispatchToProps = dispatch => ({});

const ConnectedWeight = connect(mapStateToProps, mapDispatchToProps)(Weight);

function WeightWrapper(props) {
  const { labels } = useLanguage();
  return <ConnectedWeight {...props} labels={labels} />;
}

export default WeightWrapper;
